const SLIDE_CATEGORIES = {
  GENIUS: 'genius',
  PERFORMANCE: 'performance',
  TEAMING: 'teaming',
};

export default SLIDE_CATEGORIES;
